import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import BtnLoader from "Components/Common/Loader/BtnLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

const ConfirmDeleteModal = ({
  open,
  onClose,
  title = "Confirm Action",
  description = "Are you sure you want to proceed?",
  confirmText = "Yes",
  cancelText = "Cancel",
  onConfirm,
  isLoading = false,
  confirmBtnColor = "#c51369",
  confirmHoverColor = "#a10f5b",
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <div className="w-full">
          <div className="mb-4 flex items-center">
            <div className="mr-2 text-2xl font-bold">{title}</div>
          </div>

          <p className="mb-6 tracking-wide">{description}</p>

          <div className="flex justify-end space-x-4 tracking-wide">
            <button
              onClick={onClose}
              className="rounded bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400"
              disabled={isLoading}
            >
              {cancelText}
            </button>

            <button
              onClick={onConfirm}
              disabled={isLoading}
              style={{ backgroundColor: confirmBtnColor }}
              className="rounded px-4 py-2 text-white hover:opacity-90"
            >
              {isLoading ? <BtnLoader /> : confirmText}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteModal;
